let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bH0cj")).then(() => parcelRequire('J4dZp'));